const buildAddressInput = formValues => ({
  cartId: localStorage.getItem('blaze_cart_id'),
  user: {
    email: formValues.email.value,
    password: formValues.password.value,
    firstname: formValues.firstname.value,
    lastname: formValues.lastname.value,
    title: formValues.title.value,
    tel: formValues.tel.value,
    company: formValues.company.value,
    jobTitle: formValues.jobTitle.value,
    newsletterOptOut: formValues.newsletterOptOut.value
  },
  address: {
    firstname: formValues.firstname.value,
    lastname: formValues.lastname.value,
    address1: formValues.address1.value,
    address2: formValues.address2.value,
    city: formValues.city.value,
    postcode: formValues.postcode.value,
    country: formValues.country.value,
    county: formValues.county.value,
    tel: formValues.tel.value
  }
});

export default buildAddressInput;
